import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "app-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.css"],
})
export class AvatarComponent implements OnChanges{
  @Input() name: string = "";
  @Input() imageUrl: string | null = null;
  @Input() size: number = 50;

  @Input() color: string = "#FFFFFF";
  showInitials: boolean = false;
  initials = "";

  ngOnChanges() {
    this.initials = this.name ? this.name.toUpperCase() : "";
  }

  onError() {
    this.showInitials = true;
  }
}
